import axios from 'axios';
import { SET_UNLOCK_CHAINS } from './types';

export const setUnlockChains = (chains) => ({
  type: SET_UNLOCK_CHAINS,
  payload: chains
});

// The caller's active chain unlocks, for the app bar redo list. Screens dispatch this after a
// sign, unlock or redo so the list moves without waiting for the next poll.
export const refreshUnlockChains = () => async (dispatch) => {
  try {
    const res = await axios.get('/api/unlockchain/active');
    dispatch(setUnlockChains(Array.isArray(res.data) ? res.data : []));
  } catch {
    // leave the list as it was; the next poll retries
  }
};
